import styled from 'styled-components';
import { Tag } from 'UI';

export const PricelessTag = styled(Tag)`
  margin-inline-end: 0;
  height: 22px;
  line-height: 20px;
  padding: 1px 7px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.grey00};
  background: transparent;
`;
